var _style, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Primary_Art",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n")), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 256,
    y1: 54.8434,
    x2: 256,
    y2: 457.1566
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#550088"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF7782"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M294,81.7c65.1,0,99.8,30.2,99.8,52c0,1.6-0.6,2.4-1.1,2.8l-0.5,0.4l-0.5,0.5l-43,43.2l-28.5,28.7l37.5,15.1 c31.7,12.8,44.1,29.9,44.1,60.9c0,13.4-5.2,25.3-15.5,35.5L308,399.3l-0.3,0.3l-0.2,0.3c-18.3,19.4-51.8,30.5-91.9,30.5 c-67.8,0-105.3-29.2-105.3-49.5c0-2.5,0.5-4.2,1-4.6l0.5-0.5l0.5-0.5l46.1-46.3l0.6-0.6l0.2-0.2l24.9-26.1L151.4,286 c-24.8-12.2-34.9-28.8-34.9-57.4c0-14.8,5.7-28,17.3-39.3l78.2-78.5l0.2-0.2l0.2-0.2C229.8,92.1,259.5,81.7,294,81.7 M294,54.8 c-43,0-79,14.1-100.9,37l-78.2,78.5c-15.9,15.6-25.1,35.7-25.1,58.3c0,44.9,21.6,67.6,49.9,81.5c0,0,0,0,0,0l-46.1,46.3 c-6.3,5.7-9.8,14.1-9.8,24.5c0,37.5,49.4,76.3,132,76.3c48.9,0,88.5-14.7,111.3-38.9l78.2-78.5c14.9-14.8,23.3-33.4,23.3-54.5 c0-50-27.5-72.3-60.8-85.8l43-43.2c6.1-5.6,9.8-13.5,9.8-22.7C420.4,94.9,373.1,54.8,294,54.8L294,54.8z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.0e339962ba2c6fff6628692a231554ad.svg";
export { ForwardRef as ReactComponent };